import React from "react";
import "./Cat_Card_Clothing.scss";
import {useHistory} from "react-router-dom";

function Cat_Card_Clothing({item,merchantId}) {

    const history = useHistory();

    return(
        <div className="cat_card_clothing_container" onClick={()=>{
            history.push(`/online-clothing-list/${merchantId}/${item.uid}`)
        }}>
            <img src={item.image} alt=""/>
            <div className="footer">
                <span className="title">{item.cat}</span>
                <span className="cat">{item.name}</span>
            </div>
        </div>
    )

}
export {Cat_Card_Clothing}
